import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Car, Loader2, AlertCircle } from 'lucide-react';
export function DriverLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const {
        error: authError
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (authError) throw authError;
      navigate('/driver/app');
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0B0B0B] flex flex-col items-center justify-center p-6 text-white" data-id="element-7070">
      <div className="w-full max-w-sm space-y-8" data-id="element-7071">
        <div className="text-center" data-id="element-7072">
          <div className="w-16 h-16 bg-[#006847] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#006847]/20" data-id="element-7073">
            <Car className="w-8 h-8 text-white" data-id="element-7074" />
          </div>
          <h1 className="text-3xl font-black tracking-tight" data-id="element-7075">NOIZA Driver</h1>
          <p className="text-white/50 mt-2 text-sm" data-id="element-7076">
            Inicia sesión para empezar a recibir viajes.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4" data-id="element-7077">
          <div data-id="element-7078">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-7079">
              Correo electrónico
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="conductor@noiza.com" required data-id="element-7080" />
          </div>

          <div data-id="element-7081">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-7082">
              Contraseña
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="••••••••" required data-id="element-7083" />
          </div>

          {error && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-start gap-3 text-red-400 text-sm" data-id="element-7084">
              <AlertCircle className="w-5 h-5 shrink-0" data-id="element-7085" />
              <p data-id="element-7086">{error}</p>
            </div>}

          <button type="submit" disabled={loading || !email || !password} className="w-full bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2 mt-4" data-id="element-7087">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-7088" /> : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>;
}